export const ClientHome = () => {
    return (
        <h1>Client Home</h1>
    );
};